"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackTravelDates = exports.mapTravelDatesPayloadToEventMetadata = exports.TravelDatesEventType = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var TravelDatesEventType;
(function (TravelDatesEventType) {
    TravelDatesEventType["TRAVEL_DATES_SWITCH"] = "\uD83D\uDE80 search.date.switch";
    TravelDatesEventType["TRAVEL_DATES_CANCEL"] = "\uD83D\uDE80 search.date.cancel";
    TravelDatesEventType["TRAVEL_DATES_OPEN"] = "\uD83D\uDE80 search.date.open";
    TravelDatesEventType["TRAVEL_DATES_CLOSE"] = "\uD83D\uDE80 search.date.close";
    TravelDatesEventType["TRAVEL_DATES_APPLY"] = "\uD83D\uDE80 search.date.apply";
    TravelDatesEventType["TRAVEL_DATES_UPDATE"] = "\uD83D\uDE80 search.date.update";
    TravelDatesEventType["TRAVEL_DATES_OPEN_CALENDAR"] = "\uD83D\uDE80 search.date.openCalendar";
    TravelDatesEventType["TRAVEL_DATES_CLOSE_CALENDAR"] = "\uD83D\uDE80 search.date.closeCalendar";
    TravelDatesEventType["TRAVEL_DATES_UPDATE_CALENDAR"] = "\uD83D\uDE80 search.date.updateCalendar";
    TravelDatesEventType["TRAVEL_DATES_APPLY_CALENDAR"] = "\uD83D\uDE80 search.date.applyCalendar";
})(TravelDatesEventType || (exports.TravelDatesEventType = TravelDatesEventType = {}));
const mapTravelDatesPayloadToEventMetadata = (payload) => {
    return Object.assign({ duration: payload.duration, exact: payload.exact, from: typeof payload.from === 'string'
            ? payload.from
            : (0, format_1.default)(payload.from, 'yyyy-MM-dd'), to: typeof payload.to === 'string'
            ? payload.to
            : payload.to
                ? (0, format_1.default)(payload.to, 'yyyy-MM-dd')
                : '' }, (payload.source && { source: payload.source }));
};
exports.mapTravelDatesPayloadToEventMetadata = mapTravelDatesPayloadToEventMetadata;
const trackTravelDates = (action) => {
    switch (action.type) {
        case TravelDatesEventType.TRAVEL_DATES_OPEN:
        case TravelDatesEventType.TRAVEL_DATES_CANCEL:
        case TravelDatesEventType.TRAVEL_DATES_CLOSE:
        case TravelDatesEventType.TRAVEL_DATES_OPEN_CALENDAR:
        case TravelDatesEventType.TRAVEL_DATES_CLOSE_CALENDAR:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {},
                _clear: true,
            });
            break;
        case TravelDatesEventType.TRAVEL_DATES_SWITCH:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: {
                    exact: action.payload.exact,
                },
                _clear: true,
            });
            break;
        case TravelDatesEventType.TRAVEL_DATES_APPLY_CALENDAR:
        case TravelDatesEventType.TRAVEL_DATES_APPLY:
        case TravelDatesEventType.TRAVEL_DATES_UPDATE:
            (0, libs_tracking_events_1.track)({
                event: action.type,
                eventMetadata: (0, exports.mapTravelDatesPayloadToEventMetadata)(action.payload),
                _clear: true,
            });
            break;
    }
};
exports.trackTravelDates = trackTravelDates;
//# sourceMappingURL=trackTravelDates.js.map